import { useContext, type FC } from 'react';
import classnames from 'classnames';
import { PapiGallection } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

import s from './FolderBreadcrumbs.scss';

export interface Props {
  folder?: PapiGallection | null;
  subfolder?: PapiGallection | null;
  unsetSelectedSubfolderId: () => void;
}

export const FolderBreadcrumbs: FC<Props> = ({
  folder,
  subfolder,
  unsetSelectedSubfolderId,
}) => {
  const hasNewFolderFeature = useFlag('folders_layout');
  const isMobile = useContext(MobileContext);

  if ((hasNewFolderFeature && isMobile) || !folder || !subfolder) {
    return null;
  }

  return (
    <div
      className={classnames(
        s['root'],
        hasNewFolderFeature && s['folders_layout']
      )}
    >
      <div
        className={classnames(s['crumb'], s['folder'])}
        onClick={unsetSelectedSubfolderId}
      >
        {folder.name}
      </div>
      <div className={s['crumb']}>
        {subfolder.name}
        <span className={s['count']}>{subfolder.size}</span>
      </div>
    </div>
  );
};
FolderBreadcrumbs.displayName = 'FolderBreadcrumbs';

export default FolderBreadcrumbs;
